import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import type { SetOptional, SetRequired } from 'type-fest'
import { taskDocumentQueries } from '@ztechapps/task.common'

export type TaskInlineInputProps = SetRequired<SetOptional<InlineInputProps, 'mutationConfig'>, 'initialValues'>

export const TaskInlineInput = ({ parentInputComponent, mutationConfig, ...rest }: TaskInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  if (!mutationConfig) {
    mutationConfig = taskDocumentQueries.updateConfig
  }

  return <ParentInput {...{ mutationConfig, ...rest }} />
}
